import Picture from "../../atoms/picture/Picture";
import careers from "../../../assets/images/careers.png";
import careers_mob from "../../../assets/images/careers_mob.png";
import Balls from "../../modules/balls/Balls";
import Section from "../../modules/section/Section";
import {useTranslation} from "react-i18next";

const Careers = () => {
  const { t } = useTranslation();

  return (
    <>
      <Section marginBottom>
        <div className={'relative'}>
          <Picture srcDesktop={careers} srcMobile={careers_mob} alt={'Two women smiling'}/>
          <Balls/>
        </div>
      </Section>
      <Section twoColGrid container>
        <h3 className={'mb-sm'}>{t("careersTitle")}</h3>
        <p>{t("careersDescription1")}</p>
        <p className={'font-small'}>{t("careersDescription2")}</p>
      </Section>
    </>
  );
}

export default Careers;